<template>
  <v-layout wrap fill-height justify-center align-center>
    <v-flex md8 xs12>
      <v-card text class="pa-4">
        <v-flex xs12 layout justify-center align-center>
          <span class="display-4 font-weight-light mr-4 orange--text">403</span>
          <v-layout wrap>
            <v-flex xs12>
              <p class="orange--text">
                <strong>Mohon maaf,Anda tidak memiliki cukup hak untuk mengakses halaman ini !</strong>
                <br />Silahkan menghubungi administrator Anda
              </p>
            </v-flex>
            <v-flex xs12>
              <v-btn @click="logout()" class="ma-0 mt-3" color="error">Kembali ke Halaman Login</v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { API } from "@/const";
const lc = window.localStorage;
const TOKEN = "token";
export default {
  $_veeValidate: {
    validator: "new"
  },
  components: {},

  data() {
    return {};
  },
  methods: {
    // eslint-disable-next-line
    logout() {
      this.drawer = false;
      var token = lc.getItem(TOKEN);

      if (token) {
        window.location.href = `${API}/logoutcas?access_token=` + token;
        lc.removeItem(TOKEN);
      } else {
        window.location.href = `${API}/logoutcas`;
      }
      // this.$store
      // .dispatch("user/logout")
      // .then(() => this.$router.push({ name: "login" }))
      // .catch(e => e);
    }
  }
};
</script>
<style>
.timepicker {
  color: rgba(0, 0, 0, 0.87);
  padding: 9px 8px 9px;
  max-width: 100%;
  width: 100%;
  border: 1px solid grey;
  outline: 1px;
  background: transparent;
  border-radius: 4px;
}
.vdatetime-input {
  width: 500px;
}
</style>